<template>
  <div>
    <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="700px" :destroy-on-close="true"
      :before-close="cancel">
      <el-form label-width="110px" ref="form" :model="form" :rules="rules">
        <el-form-item label="课题组名称" prop="groupName">
          <div style="display: flex;flex-direction: column">
            <el-input size="small" v-model="form.groupName" auto-complete="off" placeholder="请输入课题组名称"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="所属客户单位" prop="customerCompanyId">
          <el-select v-model="form.customerCompanyId" placeholder="请选择客户单位" filterable>
            <el-option v-for="item in filteredOptions" :key="item.id" :label="item.companyName"
              :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售" prop="salesUuid">
          <el-select v-model="form.salesUuid" placeholder="请选择销售" filterable>
            <el-option v-for="item in salesOptions" :key="item.uuid" :label="item.name" :value="item.uuid"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人姓名" prop="principalInvestigator">
          <div style="display: flex;flex-direction: column">
            <el-input size="small" v-model="form.principalInvestigator" auto-complete="off"
              placeholder="请输入负责人姓名"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="负责人电话号码" prop="mobilePhone">
          <div style="display: flex;flex-direction: column">
            <el-input size="small" v-model="form.mobilePhone" auto-complete="off" placeholder="请输入负责人电话号码"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="负责人邮箱" prop="email">
          <div style="display: flex;flex-direction: column">
            <el-input size="small" v-model="form.email" auto-complete="off" placeholder="请输负责人入邮箱"></el-input>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input size="large" v-model="form.remark" type="textarea" :autosize="{ minRows: 3 }" maxlength="300"
            show-word-limit placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="handle">保存</el-button>
      </div>
    </el-dialog>
    <loading :loading="loading" load-text="提交中"></loading>
  </div>
</template>

<script>

import {getAllCompanyName} from "@/api/dilivery/customer/company";
import {checkMail} from "@/utils/rules";
import { getPersonByType, getPersonById } from "@/api/dilivery/customer/person";
import {addGroup,editGroup} from "@/api/dilivery/customer/researchGroup";
import {getDataInLocalStorage} from "@/utils/localStorage";
import Loading from "@/components/loading/Loading.vue";

export default {
  name: "AddCustomerGroup",
  props:['showDialog','selectType','selectDetail'],
  components: { Loading },
  data(){
    return{
      loading:false,
      salesOptions: [],
      filteredOptions: [],
      title:'',
      role: '',
      userData:{},
      form:{
        salesUuid: '',
        customerCompanyId: '',
        groupName: '',
        principalInvestigator: '',
        administrativePosition: '',
        title: '',
        mobilePhone: '',
        fixedPhone: '',
        email: '',
        remark: ''
      },
      rules: {
        salesUuid: [
          {required: true, message: '请选择销售员', trigger: 'change'}
        ],
        customerCompanyId: [
          {required: true, message: '请选择客户单位', trigger: 'change'}
        ],
        groupName: [
          {required: true, message: '请输入课题组名称', trigger: 'change'}
        ],
        principalInvestigator: [
          {required: true, message: '请输入课题组负责人/科室主任', trigger: 'change'}
        ],
        fixedPhone: [
          {message: '请输入固定电话号码', trigger: 'change'}
        ],
        mobilePhone: [
          {message: '请输入手机电话号码', trigger: 'change'}
        ],
        email: [
          {required: true, message: '请输入邮箱', trigger: 'change'},
          {validator: checkMail, trigger: 'change'}
        ],
        title: [
          {message: '请输入职称', trigger: 'change'}
        ],
        administrativePosition: [
          {message: '请输入行政职位', trigger: 'change'}
        ],
        remark: [
          {message: '请输入备注', trigger: 'change'}
        ]
      },
    }
  },
  created() {
    this.userData = JSON.parse(getDataInLocalStorage('user'))
    this.role = getDataInLocalStorage('role')
  },
  mounted() {
    this.getSalesOptions();
    this.getCompanyOptions();
  },
  watch:{
    'selectType':{
      handler(newVal){
        if (newVal){
          if(newVal.type==='edit'){
            this.title='编辑客户课题组信息'
          }else {
            this.title='添加客户课题组信息'
          }
        }
      },
      immediate:true
    },
    'selectDetail':{
      handler(newVal){
        if(newVal&&Object.keys(newVal)){
          this.form.id = newVal.id
          if(newVal.customerCompanyId){
            this.form.customerCompanyId = newVal.customerCompanyId
          }
          if(newVal.salesUuid){
            this.form.salesUuid = newVal.salesUuid
          }
          this.form.name = newVal.name
          this.form.companyId = newVal.companyId
          this.form.groupName = newVal.groupName
          this.form.fixedPhone = newVal.fixedPhone
          this.form.mobilePhone = newVal.mobilePhone
          this.form.email = newVal.email
          this.form.principalInvestigator = newVal.principalInvestigator
          this.form.title = newVal.title
          this.form.administrativePosition = newVal.administrativePosition
          this.form.remark = newVal.remark
        }
      },
      immediate:true
    }
  },
  methods:{
    checkuser(){
      if(this.salesOptions.some(item => item.uuid === this.userData['personUuids'][0])){
        if( this.form.salesUuid === ''){
          this.form.salesUuid = this.userData['personUuids'][0];
        }
      }
    },
    getSalesOptions() {
      try {
        if (['ADMIN', 'MANAGER', 'SALES_ASSI_MANAGER', 'SALES_ASSI'].includes(this.role)) {
          getPersonByType('SALES', {}).then(res => {
            if (res.code === 200) {
              this.salesOptions = res.data;
              this.checkUser();
            }
          }).catch(err => { })
        } else {
          getPersonById(this.userData['personUuids'][0], {}).then(res => {
            if (res.code === 200) {
              this.salesOptions = res.data;
              this.checkUser();
            }
          }).catch(err => { })
        }
      } catch (error) {
        console.log(error);
      }
    },
    getCompanyOptions() {
      try {
        getAllCompanyName().then(res => {
          if (res.code === 200){
            this.filteredOptions = res.data
          }
        })
      } catch (error) {
        console.log(error);
      }
    },
    cancel(){
      this.$emit('submit','cancel')
    },
    handle(){
      this.$refs.form.validate(valid=>{
        if(valid){
          this.loading = true
          // 请求方法
          if (this.title === '添加客户课题组信息') {
            addGroup(this.form).then(res => {
              if (res.code === 200) {
                this.loading = false
                this.$emit('submit','confirm')
                this.$messageUi.success('添加成功')
              }
            }).catch(err => {
              this.loading = false
            })
          } else {
            editGroup(this.form).then(res => {
              if (res.code === 200) {
                this.loading = false
                this.$emit('submit','confirm')
                this.$messageUi.success('修改成功')
              }
            }).catch(err => {
              this.loading = false
            })
          }
        }else {
          this.$nextTick(() => {
            let err = document.getElementsByClassName('is-error')
            if (err.length) {
              err[0].scrollIntoView({
                block: 'center',
                behavior: 'smooth',
              })
            }
          })
          this.$messageUi.error('填写参数不规范，请检查')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
